import { ReactNode } from "react"
import { Container } from "reactstrap"
import Breadcrumb from "Components/organisms/breadcrumb"
import ErrorState from "Components/organisms/error-state"
import LoadingState from "Components/organisms/loading-state"
import ActionButton from "Components/atoms/buttons/action-button"
import HrReportActions from "Components/organisms/hr-reports/report-actions"

interface HrReportTemplateProps {
    title: string
    manual: string
    isLoading: boolean
    hasError: boolean
    onRetry: () => void
    children: ReactNode
}

// Page frame for the HR reports (Demographics, Anniversary, Retention)
const HrReportTemplate = ({ title, manual, isLoading, hasError, onRetry, children }: HrReportTemplateProps) => (
    <div className="page-content">
        <Container fluid className="hr-report">
            <Breadcrumb
                title="Human Resources"
                breadcrumbItem={title}
                actions={<HrReportActions manual={manual} />}
            />
            {isLoading
                ? <div className="section-container"><LoadingState title={`Loading ${title}`} subtitle="Fetching employee data..." /></div>
                : hasError
                    ? <div className="section-container">
                        <ErrorState
                            title={`Unable to load ${title.toLowerCase()}`}
                            action={<ActionButton onClick={onRetry}>Try again</ActionButton>}
                        />
                    </div>
                    : children}
        </Container>
    </div>
)

export default HrReportTemplate
